import { Button } from '@pickleballinc/ui/components/ui/button';
import clsx from 'clsx';
import type { ReactElement } from 'react';

interface ShopButtonProps {
  className?: string;
  /** The rendered element — an `<a>` for a standalone link, or a `<span>` when nested in a link. */
  children: ReactElement;
}

export const ShopButton = ({ className, children }: ShopButtonProps) => (
  <Button
    asChild
    className={clsx(
      'h-auto rounded-lg bg-darkorange-400 px-3 py-2 text-sm font-semibold text-white shadow-none transition-opacity hover:bg-darkorange-400 hover:opacity-90 focus-visible:ring-2 focus-visible:ring-darkorange-400 focus-visible:ring-offset-2',
      className
    )}
  >
    {children}
  </Button>
);
